/**
 * InfinitSales - Inbox do Facebook Messenger
 *
 * Wrapper fino sobre o shell COMPARTILHADO do inbox
 * (components/inbox/Inbox.jsx): toda a fiacao do canal mora no adaptador
 * (components/inbox/channelAdapters/messenger.js). Extraido em 2026-09-23
 * (fase 4 do inbox do widget); antes este arquivo tinha 944 linhas clonadas
 * do Instagram.
 */
import React from 'react';
import ChannelInbox from '../../components/inbox/Inbox';
import messengerAdapter from '../../components/inbox/channelAdapters/messenger';

const MessengerInbox = () => <ChannelInbox adapter={messengerAdapter} />;

export default MessengerInbox;
